import React from 'react';
import { FormControlLabel, Checkbox } from '@material-ui/core';
import { notifySuccess, notifyError } from '../../Messages/Notification.js';
import MultiFactorAuthenticationModal from './MultiFactorAuthenticationModal.js';
import { getUserOtpAuthUrl } from '../../../services/AdministratorService.js';
import { useConfirm } from 'material-ui-confirm';
import {
  removeUserOtpAuth,
  updateUserOtpAuth,
} from '../../../services/AdministratorService.js';
import { Button } from '@mui/material';

export const CheckboxAuthenticatorApp = ({
  disabled,
  name,
  checked,
  onChange,
  ...rest
}) => {
  const confirm = useConfirm();
  const [mfaUrl, setMfaUrl] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const handleOpenMfaModal = async () => {
    try {
      const { url } = await getUserOtpAuthUrl();
      setMfaUrl(url);
      onChange({
        target: {
          name: 'hasMfaKeys',
          value: true,
        },
      });
    } catch (error) {
      notifyError(error.message);
    }
  };

  const handleCloseMfaModal = () => {
    setMfaUrl('');
  };

  const handleSaveMfa = async (code) => {
    if (!code) {
      return notifyError('Validation Code is required.');
    }
    setLoading(true);

    try {
      await updateUserOtpAuth(code);
      notifySuccess('Authentication app connection is validated.');
      onChange({
        target: {
          name,
          value: true,
        },
      });

      handleCloseMfaModal('');
    } catch (error) {
      notifyError(error.message);
    }

    setLoading(false);
  };

  const handleRemoveAuthenticatorApp = async () => {
    try {
      await confirm({
        description: 'You are about remove your MFA Setup. Please confirm your action.',
        confirmationText: 'Yes, remove',
      });
    } catch (error) {
      return;
    }

    setLoading({ ...loading, authenticatorApp: true });
    try {
      await removeUserOtpAuth();
      notifySuccess('MFA Setup is removed.');
      onChange({
        target: {
          name,
          value: false,
        },
      });
      onChange({
        target: {
          name: 'hasMfaKeys',
          value: false,
        },
      });
    } catch (error) {
      notifyError(error.message);
    }
    setLoading({ ...loading, authenticatorApp: false });
  };

  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            disabled={disabled}
            checked={checked}
            onChange={onChange}
            name={name}
            {...rest}
          />
        }
        label={
          <>
            <span>Authenticator</span>
            {
              <Button variant="text" onClick={handleOpenMfaModal}>
                Connect App
              </Button>
            }
            {!disabled && (
              <Button variant="text" onClick={handleRemoveAuthenticatorApp}>
                Remove Setup
              </Button>
            )}
          </>
        }
      />
      {mfaUrl && (
        <MultiFactorAuthenticationModal
          open={!!mfaUrl}
          mfaUrl={mfaUrl}
          onSubmit={handleSaveMfa}
          onClose={handleCloseMfaModal}
          loading={loading.auth}
        />
      )}
    </>
  );
};
